import { createDeferredAction } from '../../utils/redux';
import { INFORMATION_SCREEN_WRAPPER } from '../../configs/moduleNames';

export const ADD_GLOBAL_POPUP_WRAPPER = '_ADD_GLOBAL_POPUP_WRAPPER';
export const CLEAR_GLOBAL_POPUP_WRAPPER = '_CLEAR_GLOBAL_POPUP_WRAPPER';
export const CLOSE_ALL_POPUP_WRAPPER = '_CLOSE_ALL_POPUP_WRAPPER';

export const addGlobalPopUpWrapper = createDeferredAction(INFORMATION_SCREEN_WRAPPER + ADD_GLOBAL_POPUP_WRAPPER);
export const clearGlobalPopUpWrapper = createDeferredAction(INFORMATION_SCREEN_WRAPPER + CLEAR_GLOBAL_POPUP_WRAPPER);
export const closeAllPopupWrapper = createDeferredAction(INFORMATION_SCREEN_WRAPPER + CLOSE_ALL_POPUP_WRAPPER);
